import { Editor, type Node, type Path, type NodeEntry } from 'slate';
import PathUtils from './PathUtils';

interface NodeFindOpts {
  match?: (node: Node, path: Path) => boolean;
}

class NodeUtils {
  static nextSibling(
    editor: Editor,
    path: Path,
    opts: NodeFindOpts = {}
  ): NodeEntry | undefined {
    if (!PathUtils.hasNext(editor, path)) return;
    const nextSiblingPath = PathUtils.nextSiblingPath(path);
    const [nextSibling] = Editor.node(editor, nextSiblingPath);

    if (!opts.match || opts.match(nextSibling, nextSiblingPath)) {
      return [nextSibling, nextSiblingPath];
    }
  }

  static previousSibling(
    editor: Editor,
    path: Path,
    opts: NodeFindOpts
  ): NodeEntry | undefined {
    if (!PathUtils.hasPrevious(editor, path)) return;

    const previousSiblingPath = PathUtils.previousSiblingPath(path);
    const previousSiblingEntry = Editor.node(editor, previousSiblingPath);
    if (!previousSiblingEntry) return;

    const [previousSibling] = previousSiblingEntry;
    if (!opts.match || opts.match(previousSibling, previousSiblingPath)) {
      return previousSiblingEntry;
    }
  }
}

export default NodeUtils;
